'use strict';

import React from 'react';
import { Provider, connect } from 'react-redux';
@connect((state) => {
    return {
        cart: state.get('cart'),
        form: state.get('form')
    };
})
class CartHeader extends React.Component {
    render() {
        let size = this.props.cart.get('products').reduce((r, n) => {
            return r + n.get('quantity');
        }, 0);

        return (
            <a href="/warenkorb">
                <i className="icon icon-cart"></i>
                <span className="cart__description">Warenkorb ({size})</span>
            </a>
        );
    }
}

export default class Cart extends React.Component {
    render() {
        return (
            <Provider store={this.props.cartStore}>
                <CartHeader {...this.props} />
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/cart/index.jsx